export const PRICE_LIST_SOURCES = {
  CUSTOM: 'custom',
  PLATFORM: 'platform',
  INTEGRATION: 'integration',
} as const;

export type PriceListRule = {
  source_price_list_slug: string;
  adjustment_percentage: number;
  adjustment_direction: 'plus' | 'minus';
  currency_exchange_rate?: number;
};

export type PriceListSource = (typeof PRICE_LIST_SOURCES)[keyof typeof PRICE_LIST_SOURCES];

export type PriceList = {
  source: PriceListSource;
  name: string;
  slug: string;
  currency_code: string;
  rules: PriceListRule[];
};

export type PriceListApiResponse = PriceList & {
  num_manual_prices: number;
};

export type PriceListEdit = Omit<PriceList, 'slug' | 'source' | 'currency_code'>;
